import React from 'react'

import { SEXUALITY_OPTIONS } from 'constants/user'
import { strings } from 'helpers'

import Label from './Label'
import Select from './Select'

const InputSexuality = ({ onChange, userData }) => {
  return (
    <div>
      <Label>Sexuality</Label>
      <Select
        name="userSexualOrientation"
        defaultLabel="Sexuality"
        options={SEXUALITY_OPTIONS}
        onChange={onChange}
        value={strings.valueOrEmptyString(userData.userSexualOrientation)}
      />
    </div>
  )
}

export default InputSexuality
